import React, { useState, useMemo, useEffect, useRef } from 'react';
import TimestampRangePicker from '@/components/timestamp-RangePicker';
import { Select, Button, TreeSelect } from '@drip/drip-design';
import moment from 'moment';
import { PLATFORM_TYPE } from './config';
import './index.less';
import { RangePickerProps } from '@drip/drip-design/lib/date-picker';

const format = 'YYYY-MM-DD';
const now_618 = moment().year() + '-06-18';
const now_1111 = moment().year() + '-11-11';
const defaultBeginDate = moment().subtract(9, 'day').format(format);
const defaultEndDate = moment().subtract(2, 'day').format(format);

function FloorSearchbar(props: any) {
  const { onChange, dataScopeDept } = props;
  const _onChange = useRef(onChange);
  // 平台
  const [platformType, setPlatformType] = useState(PLATFORM_TYPE[0].value);
  // 开始结束时间
  const [date, setDate] = useState({
    beginDate: defaultBeginDate,
    endDate: defaultEndDate,
  });
  const [userType] = useState('dept');
  // 对比时间列表
  const options = useMemo(() => {
    let _options = [];
    if (moment().startOf('day') > moment(now_618)) {
      _options.push({
        label: '对比今年618',
        value: '1',
      });
    }
    if (moment().startOf('day') > moment(now_1111)) {
      _options.push({
        label: '对比今年双11',
        value: '2',
      });
    }
    _options.push(
      {
        label: '对比去年618',
        value: '3',
      },
      {
        label: '对比去年双11',
        value: '4',
      },
      {
        label: '同比',
        value: '5',
      },
      {
        label: '环比',
        value: '6',
      },
      {
        label: '自定义',
        value: '7',
      }
    );
    return _options;
  }, []);
  // 对比类型
  const [vsType, setVsType] = useState('6');
  // 对比时间
  const getSequentialDate = (beginDate?: string, endDate?: string) => {
    const beginDateCache = beginDate || defaultBeginDate;
    const endDateCache = endDate || defaultEndDate;
    const dataRange = moment(endDateCache).valueOf() - moment(beginDateCache).valueOf();
    const cBeginDate = moment(moment(beginDateCache).subtract(1, 'day').valueOf() - dataRange).format(format);
    const cEndDate = moment(beginDateCache).subtract(1, 'day').format(format);
    return {
      cBeginDate,
      cEndDate,
    };
  };
  const [vsDate, setVsDate] = useState(getSequentialDate());
  // 对比时间联动修改
  useEffect(() => {
    const dataRange = moment(date.endDate).valueOf() - moment(date.beginDate).valueOf();
    switch (vsType) {
      case '1':
        setVsDate({
          cBeginDate: moment(moment(now_618).valueOf() - dataRange).format(format),
          cEndDate: now_618,
        });
        return;
      case '2':
        setVsDate({
          cBeginDate: moment(moment(now_1111).valueOf() - dataRange).format(format),
          cEndDate: now_1111,
        });
        return;
      case '3':
        setVsDate({
          cBeginDate: moment(moment(moment().year() - 1 + '-06-18').valueOf() - dataRange).format(format),
          cEndDate: moment().year() - 1 + '-06-18',
        });
        return;
      case '4':
        setVsDate({
          cBeginDate: moment(moment(moment().year() - 1 + '-11-11').valueOf() - dataRange).format(format),
          cEndDate: moment().year() - 1 + '-11-11',
        });
        return;
      case '5':
        setVsDate({
          cBeginDate: moment(moment(date.endDate).subtract(1, 'year').valueOf() - dataRange).format(format),
          cEndDate: moment(date.endDate).subtract(1, 'year').format(format),
        });
        return;
      case '6':
        setVsDate(getSequentialDate(date.beginDate, date.endDate));
        return;
      default:
        return;
    }
  }, [vsType, date]);

  const findFirstAvailableCode = (arr: any) => {
    let deptFull = { initDeptFullcode: [], initDeptFullName: '' };
    function findCode(list: any) {
      const code = list.find((item: any) => !item.disabled);
      if (!code && list[0].children && list[0].children.length) {
        findCode(list[0].children);
      } else {
        deptFull = {
          initDeptFullcode: code.deptFullCode.split('/'),
          initDeptFullName: code.deptFullName,
        };
      }
    }
    findCode(arr);
    return { ...deptFull };
  };

  const { initDeptFullcode, initDeptFullName } = findFirstAvailableCode(dataScopeDept);
  const [deptFullName, setDeptFullName] = useState(initDeptFullName);
  const [deptFullCode, setDeptFullCode] = useState<string[]>(initDeptFullcode);
  /**
   * 选择部门
   */
  const getdeptInfo = (isReset = false) => {
    const fullCode = isReset ? initDeptFullcode : deptFullCode;
    return {
      buId: fullCode[0] || '',
      deptId1: fullCode[1] || '',
      deptId2: fullCode[2] || '',
      deptId3: fullCode[3] || '',
      deptId4: fullCode[4] || '',
      userType: userType,
    };
  };
  /**
   * 搜索
   */
  const onSearch = () => {
    console.log('查询');
    onUpdata({
      ...getdeptInfo(),
      ...date,
      ...vsDate,
      criteria: {
        platform_cate_1: platformType,
      },
    });
  };
  /**
   * 重置
   */
  const onReset = () => {
    setPlatformType(PLATFORM_TYPE[0].value);
    setDeptFullName(initDeptFullName);
    setDeptFullCode(initDeptFullcode);
    setVsType('6');
    setDate({
      beginDate: defaultBeginDate,
      endDate: defaultEndDate,
    });
    onUpdata({
      ...getdeptInfo(true),
      beginDate: defaultBeginDate,
      endDate: defaultEndDate,
      ...getSequentialDate(),
      criteria: {
        platform_cate_1: platformType,
      },
    });
    console.log('重置');
  };

  /**
   * 更新搜索数据
   * @param conditions
   * @returns
   */
  const onUpdata = (conditions: {
    criteria: { platform_cate_1: string };
    cBeginDate: string;
    cEndDate: string;
    beginDate: string;
    endDate: string;
  }) => {
    if (!_onChange.current || !vsDate.cBeginDate) return;
    _onChange.current(conditions);
  };

  /**
   * 时间类型选择
   * @param e
   */
  const disabledDate: RangePickerProps['disabledDate'] = (current) => {
    const baseDate = date.beginDate || defaultEndDate;
    return (
      current &&
      (current >
        moment(baseDate)
          .day(moment(baseDate).isoWeekday() + 30)
          .endOf('day') ||
        current < moment(baseDate).day(moment(baseDate).isoWeekday() - 30))
    );
  };

  useEffect(() => {
    onSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="floor-searchbar">
        <div className="searchbar-panel">
          <div className="choose-panel">
            <div className="item">
              <div className="item-name">数据范围</div>
              <TreeSelect
                value={deptFullName}
                style={{ width: 233 }}
                allowClear={false}
                fieldNames={{ label: 'name', value: 'deptFullCode', children: 'children' }}
                treeData={dataScopeDept}
                treeNodeLabelProp="deptFullName"
                onChange={(value, label) => {
                  // console.log(value, label);
                  setDeptFullName((label ? label[0] : '') as string);
                  setDeptFullCode(value ? value.split('/') : []);
                }}
              />
            </div>
            <div className="item">
              <div className="item-name">平台</div>
              <Select onChange={setPlatformType} value={platformType} style={{ width: 260 }}>
                {PLATFORM_TYPE.map((item: any) => (
                  <Select.Option value={item.value} key={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
            </div>
          </div>
        </div>
        <div className="searchbar-panel">
          <div className="choose-panel">
            <div className="item">
              <div className="item-name">时间</div>
              <TimestampRangePicker
                allowClear={false}
                value={date}
                format={format}
                fieldNames={{ start: 'beginDate', end: 'endDate' }}
                type={TimestampRangePicker.DATA_STRING}
                onChange={setDate}
                disabledDate={disabledDate}
              />
            </div>
            <div className="item">
              <div className="item-name">对比时间</div>
              <Select onChange={setVsType} value={vsType} style={{ width: 153 }} className="contrast-type">
                {options.map((item: any) => (
                  <Select.Option value={item.value} key={item.value}>
                    {item.label}
                  </Select.Option>
                ))}
              </Select>
              <TimestampRangePicker
                allowClear={false}
                disabled={vsType !== '7'}
                value={vsDate}
                format={format}
                fieldNames={{ start: 'cBeginDate', end: 'cEndDate' }}
                type={TimestampRangePicker.DATA_STRING}
                onChange={setVsDate}
              />
            </div>
          </div>
          <div className="btn-control">
            <Button className="search" style={{ width: 80 }} onClick={onSearch}>
              查询
            </Button>
            <Button className="reset" style={{ width: 80 }} onClick={onReset}>
              重置
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
export default FloorSearchbar;
